import { render, staticRenderFns } from "./orderFlowList.vue?vue&type=template&id=68083e5a&scoped=true"
import script from "./orderFlowList.vue?vue&type=script&lang=js"
export * from "./orderFlowList.vue?vue&type=script&lang=js"
import style0 from "./orderFlowList.vue?vue&type=style&index=0&id=68083e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68083e5a",
  null
  
)

export default component.exports